<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Редагування Slider" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-card class="mb-3" title="Image">
                  <div v-if="imgExisting">
                    <a style="display: block;" target="_blank" :href="imgExisting"><img style="max-width: 400px;" :src="imgExisting"></a>
                    <div><va-button small color="danger" @click="imgExisting = deleteImage(imgId) ? '' : imgExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.image"
                    v-model="img"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('image', 'sliderImage', 'SliderMain[image]', img[0])">Завантажити</va-button>
                  <div v-if="errors.image" style="color: red;">{{ errors.image[0] }}</div>
                </va-card>
                <va-card class="mb-3" title="Image Mobile">
                  <div v-if="imgMobileExisting">
                    <a style="display: block;" target="_blank" :href="imgMobileExisting"><img style="max-width: 400px;" :src="imgMobileExisting"></a>
                    <div><va-button small color="danger" @click="imgMobileExisting = deleteImage(imgMobileId) ? '' : imgMobileExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.imageMobile"
                    v-model="imgMobile"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('imageMobile', 'sliderImageMobile', 'SliderMain[imageMobile]', imgMobile[0])">Завантажити</va-button>
                  <div v-if="errors.imageMobile" style="color: red;">{{ errors.imageMobile[0] }}</div>
                </va-card>
                <va-card class="mb-3" title="Video">
                  <div v-if="videoExisting">
                    <a class="link" style="display: block;" target="_blank" :href="videoExisting">{{ videoExisting }}</a>
                    <div><va-button small color="danger" @click="videoExisting = deleteImage(videoId) ? '' : videoExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити новий файл</span>
                  <va-file-upload
                    dropzone
                    v-model="video"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('video', 'sliderVideo', 'SliderMain[video]', video[0])">Завантажити</va-button>
                </va-card>
                <va-input
                  label="Label"
                  v-model="label"
                  @input="delete errors.label"
                  :error="!!errors.label"
                  :error-messages="errors.label"
                />
                <va-input
                  label="Description"
                  v-model="description"
                  @input="delete errors.description"
                  :error="!!errors.description"
                  :error-messages="errors.description"
                />
                <va-input
                  label="Button label"
                  v-model="buttonLabel"
                  @input="delete errors.buttonLabel"
                  :error="!!errors.buttonLabel"
                  :error-messages="errors.buttonLabel"
                />
                <va-input
                  label="Button link"
                  v-model="buttonLink"
                  @input="delete errors.buttonLink"
                  :error="!!errors.buttonLink"
                  :error-messages="errors.buttonLink"
                />
                <va-toggle label="Published" small v-model="published"/>
                <va-input
                  label="Position"
                  v-model.number="position"
                  @input="delete errors.position"
                  :error="!!errors.position"
                  :error-messages="errors.position"
                />
                <va-button @click="submit()">Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      img: [],
      imgId: '',
      imgExisting: '',
      imgMobile: [],
      imgMobileId: '',
      imgMobileExisting: '',
      video: [],
      videoId: '',
      videoExisting: '',
      label: '',
      description: '',
      buttonLabel: '',
      buttonLink: '',
      position: '',
      published: false,

      sign: '',

      errors: [],

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
    const generateRandomString = (length = 6) => Math.random().toString(20).substr(2, length)
    this.sign = generateRandomString(32)
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    uploadImage (attr, entityAttribute, param, file) {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append('model_name', 'backend\\modules\\slider\\models\\SliderMain')
      formData.append('attribute', attr)
      formData.append('entity_attribute', entityAttribute)
      formData.append(param, file)
      formData.append('file_id', '0')
      formData.append('multiple', '0')

      if (this.$attrs.id) {
        formData.append('id', this.$attrs.id)
      } else {
        formData.append('sign', this.sign)
      }

      axios.post(`${process.env.VUE_APP_1LK_API_URL}/admin/upload?lang=${this.locale}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id) {
      return axios.delete(`${process.env.VUE_APP_1LK_API_URL}/admin/upload/${id}?lang=${this.locale}`)
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    submit () {
      const data = {
        label: this.label,
        position: this.position,
        published: this.published ? 1 : 0,
        description: this.description,
        button_label: this.buttonLabel,
        button_link: this.buttonLink,

        sign: this.sign ? this.sign : null,
      }
      if (this.$attrs.id) { // update
        axios.put(`${process.env.VUE_APP_1LK_API_URL}/admin/main-slider/${this.$attrs.id}?lang=${this.locale}`, data)
          .then(response => {
            this.$router.push({ name: '1lk-home-slider' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      } else {
        axios.post(`${process.env.VUE_APP_1LK_API_URL}/admin/main-slider?lang=${this.locale}`, data)
          .then(response => {
            this.$router.push({ name: '1lk-home-slider' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      if (this.$attrs.id) {
        axios.get(`${process.env.VUE_APP_1LK_API_URL}/admin/main-slider/${this.$attrs.id}?lang=${this.locale}`)
          .then(response => {
            console.log(response.data)
            this.label = response.data.label
            this.position = response.data.position
            this.published = !!response.data.published
            this.description = response.data.description
            this.buttonLabel = response.data.button_label
            this.buttonLink = response.data.button_link

            this.imgExisting = response.data.image ? process.env.VUE_APP_1LK_ADMIN + response.data.image : ''
            this.imgId = response.data.image_id
            this.imgMobileExisting = response.data.mobile_image ? process.env.VUE_APP_1LK_ADMIN + response.data.mobile_image : ''
            this.imgMobileId = response.data.mobile_image_id
            this.videoExisting = response.data.video ? process.env.VUE_APP_1LK_ADMIN + response.data.video : null
            this.videoId = response.data.video_id
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
